module.exports = {"632626100":"玛查理镇","632626101":"花石峡镇","632626200":"黄河乡","632626201":"扎陵湖乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632626.json
// module id = 2797
// module chunks = 0